<template>
  <div class="entrance-payment-wrapper">
    <div class="entrance-payment-header" />
    <div :style="{ marginLeft: !isOnlyCredit ? '55px' : '0px' }" class="entrance-payment-title">
      Pagamento da entrada
    </div>
    <div class="entrance-payment-details">
      <div>
        <div class="entrance-payment-details-title">Valor da Entrada</div>
        <div class="entrance-payment-details-value">
          {{ moneyFilter(downPayment.downPaymentValue) }}
        </div>
      </div>
      <div>
        <div class="entrance-payment-details-title">Vencimento</div>
        <div class="entrance-payment-details-value">
          {{ downPayment.downPaymentDueDate }}
          {{ downPayment.downPaymentDueDate > 1 ? 'dias úteis' : 'dia útil' }}
        </div>
      </div>
    </div>
    <PaymentSelector
      :downPaymentValue="downPayment.downPaymentValue"
      :options="options"
    />
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import PaymentSelector from './PaymentSelector.vue';

export default {
  props: {
    downPayment: {
      type: Object,
    },
  },
  mixins: [StringMixin, UtilMixin],
  components: {
    PaymentSelector,
  },
  computed: {
    isOnlyCredit() {
      return this.$route.query?.payWithCredit;
    },
    options() {
      const optionsArray = [];

      if (this.downPayment?.downPaymentPixAvailable) {
        optionsArray.push({
          pixCode: this.downPayment?.downPaymentPixCode,
          type: 'pix-method',
          label: 'Pix',
        });
      }

      if (this.downPayment?.retailerName !== 'AME') {
        optionsArray.push({
          downPaymentLink: this.downPayment?.downPaymentLink,
          payNumber: this.downPayment?.payNumber,
          barCodeNumber: this.downPayment?.barCodeNumber,
          type: 'billet-method',
          label: 'Boleto',
        });
      }

      if (this.downPayment?.isCreditCardAvailable) {
        optionsArray.push({
          type: 'credit-card',
          label: 'Cartão',
        });
      }

      return optionsArray;
    },
  },
};
</script>

<style lang="scss" scoped>
.entrance-payment-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #212B36;
}
.entrance-payment-details {
  display: grid;
  grid-template-columns: 50% 50%;
  margin-top: 26px;
  margin-bottom: 20px;
}
.entrance-payment-details-title {
  font-size: 14px;
  line-height: 20px;
  color: #212B36;
  margin-bottom: 8px;
}
.entrance-payment-details-value {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #212B36;
}
@media (max-width: $sm) {
  .entrance-payment-wrapper {
    padding-top: 32px;
    width: unquote("Calc(100vw - 48px) !important");
  }
  .entrance-payment-title {
    margin-left: 55px;
    margin-top: 5px;
    position: absolute;
    top: 32px;
    z-index: 1;
  }
}
</style>
